export default ['TransportService', 'EventHub', '$q', function (Transport, EventHub, $q) {
    Transport.subscribe(function (promise, requestId, xCenter, serviceEndpoint, method, params) {
        var t0 = Date.now();
        return promise.then(function (response) {
            var elapsed = Date.now() - t0;
            EventHub.publish('tracking', 'serverCall', {
                path: serviceEndpoint,
                method: method,
                elapsedTime: elapsed,
                requestId: requestId,
                params: params,
                response: response
            });
            return response;
        }, function (error) {
            var elapsed = Date.now() - t0;
            var errorMessage = '';
            // Catch exception should any property before 'message' not be defined
            try {
                if (angular.isDefined(error.baseError.data.error.message)) {
                    errorMessage = error.baseError.data.error.message;
                }
            } catch (e) {
                console.error('No error message defined.');
            }

            EventHub.publish('tracking', 'serverCallError', {
                path: serviceEndpoint,
                method: method,
                elapsedTime: elapsed,
                params: params,
                errorMessage: errorMessage,
                requestId: requestId
            });
            return $q.reject(error);
        });
    });
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-tracking-angular/transport.js
// module id = 916
// module chunks = 0